export const GLOBAL_API_ROUTES = {
    LOGIN: "/login",
    SIGN_UP: '/signup',
    FINAL_VALUES: '/finalValues',
    PROGRESS: '/progress',
    REVISIT: '/revisit',
}